import Paragraph from 'elements/Paragraph';
import ds, { media } from 'designsystem';

const ContactData = Paragraph.extend`
  font-weight: ${ds.get('type.fontWeight.regular')};
  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  margin-bottom: 0;
  margin-top: calc(${ds.get('metrics.xs')} / 3);
  font-size: ${ds.fontSize('s')};
  
  ${media.tablet`
     font-size: ${ds.fontSize('base')};
  `}
`;

export default ContactData;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/ContactData.jsx